export enum AmenityType {
	Balcony = 1,
	Terrace = 2,
	FrontGarden = 3,
	ParkingPlace = 4,
	StorageFacility = 5
}
